import React from "react";
import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { ActivityDirection } from "@/entities/activities/types";
import { cn } from "@/utils/utils";

interface Props {
  direction: ActivityDirection;
}

const ActivityDirectionIndicator: React.FC<Props> = ({ direction }) => {
  const { t } = useTranslation();
  const label = t(`activities.direction.${direction}`);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          role="img"
          aria-label={label}
          // Focusable, so the tooltip also opens from the keyboard.
          tabIndex={0}
          data-test={`activity-direction-${direction}`}
          className="flex"
        >
          {/* A received item points the sent arrow back down-left. */}
          <IconContainer
            as="span"
            size="sm"
            color="tertiary"
            className={cn(direction === "inbound" && "rotate-180")}
          >
            <ArrowUpRight />
          </IconContainer>
        </span>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
};

export default ActivityDirectionIndicator;
